/**
 * Sampling distributions of a mean and of a proportion.
 *
 * By the central limit theorem x̄ is approximately N(μ, σ/√n) and p̂ approximately
 * N(p, √(p(1 − p)/n)); exactly so for x̄ when the population itself is normal. The
 * probabilities are then normal areas (`normal.ts`) with the standard error as the SD.
 */

export function meanStandardError(sigma: number, n: number): number {
  return sigma / Math.sqrt(n);
}

export function proportionStandardError(p: number, n: number): number {
  return Math.sqrt((p * (1 - p)) / n);
}

/** The usual rule of thumb before trusting the normal approximation for p̂. */
export const SUCCESS_FAILURE_MINIMUM = 10;

/** A common, rough rule for "large enough" when the population is not normal. */
export const CLT_RULE_OF_THUMB = 30;

export function successFailureCheck(
  p: number,
  n: number
): { expectedSuccesses: number; expectedFailures: number; ok: boolean } {
  const expectedSuccesses = n * p;
  const expectedFailures = n * (1 - p);
  return {
    expectedSuccesses,
    expectedFailures,
    ok:
      expectedSuccesses >= SUCCESS_FAILURE_MINIMUM &&
      expectedFailures >= SUCCESS_FAILURE_MINIMUM,
  };
}
